import type { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('@/pc/layouts/MainLayout.vue');
const HomeLayout = () => import('@/pc/layouts/HomeLayout.vue');

export const pcRoutes: RouteRecordRaw[] = [
  {
    path: '/',

    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'landing',
        component: () => import('@/pc/views/home/Landing.vue'),
        meta: { public: true, title: 'ESCMM - 企业级二手车买卖管理系统' },
      },
    ],
  },
  {
    path: '/pc/login',
    name: 'login',
    component: () => import('@/pc/views/login/Login.vue'),
    meta: { public: true, title: '登录' },
  },
  {
    path: '/pc/trial',
    name: 'trial',
    component: () => import('@/pc/views/login/Trial.vue'),
    meta: { public: true, title: '免费试用' },
  },
  {

    path: '/pc',
    component: MainLayout,
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/pc/views/dashboard/Dashboard.vue'),
        meta: { title: '工作台', permissions: ['dashboard:view'] },
      },
{
  path: 'super-admin',
  name: 'super-admin',
  component: () => import('@/pc/views/super-admin/SuperAdmin.vue'),
  meta: { title: '超管工作台', roles: ['super_admin'] },
},
{
  path: 'content-marketing',
  name: 'content-marketing',
  component: () => import('@/pc/views/super-admin/ContentMarketing.vue'),
  meta: { title: '文案推广', roles: ['super_admin'] },
},
{
  path: 'vehicles',
        name: 'vehicle-list',
        component: () => import('@/pc/views/vehicle/VehicleList.vue'),
        meta: { title: '车辆管理', permissions: ['vehicle:list'] },
      },
      {
        path: 'vehicles/create',
        name: 'vehicle-create',
        component: () => import('@/pc/views/vehicle/VehicleCreate.vue'),
        meta: { title: '新增车辆', permissions: ['vehicle:create'] },
      },
      {
        path: 'vehicles/:uuid',
        name: 'vehicle-detail',
        component: () => import('@/pc/views/vehicle/VehicleDetail.vue'),
        meta: { title: '车辆详情', permissions: ['vehicle:detail'] },
      },
      {
        path: 'vehicles/:uuid/edit',
        name: 'vehicle-edit',
        component: () => import('@/pc/views/vehicle/VehicleEdit.vue'),
        meta: { title: '编辑车辆', permissions: ['vehicle:update'] },
      },
      {
        path: 'evaluations',
        name: 'evaluation-list',
        component: () => import('@/pc/views/evaluation/EvaluationList.vue'),
        meta: { title: '评估管理', permissions: ['evaluation:list'] },
      },
      {
        path: 'evaluations/create',
        name: 'evaluation-create',
        component: () => import('@/pc/views/evaluation/EvaluationCreate.vue'),
        meta: { title: '新增评估', permissions: ['evaluation:create'] },
      },
      {
        path: 'evaluations/:uuid',
        name: 'evaluation-edit',
        component: () => import('@/pc/views/evaluation/EvaluationEdit.vue'),
        meta: { title: '编辑评估', permissions: ['evaluation:update'] },
      },
      {
        path: 'customers',
        name: 'customer-list',
        component: () => import('@/pc/views/customer/CustomerList.vue'),
        meta: { title: '客户管理', permissions: ['customer:list'] },
      },
      {
        path: 'customers/:uuid',
        name: 'customer-detail',
        component: () => import('@/pc/views/customer/CustomerDetail.vue'),
        meta: { title: '客户详情', permissions: ['customer:detail'] },
      },
      {
        path: 'purchase-orders',
        name: 'purchase-order-list',
        component: () => import('@/pc/views/order/PurchaseOrderList.vue'),
        meta: { title: '采购单', permissions: ['purchase_order:list'] },
      },
      {
        path: 'sales-orders',
        name: 'sales-order-list',
        component: () => import('@/pc/views/order/SalesOrderList.vue'),
        meta: { title: '销售单', permissions: ['sales_order:list'] },
      },
      {
        path: 'appointments',
        name: 'appointment-list',
        component: () => import('@/pc/views/appointment/AppointmentList.vue'),
        meta: { title: '预约管理', permissions: ['appointment:list'] },
      },
      {
        path: 'preparations',
        name: 'preparation-list',
        component: () => import('@/pc/views/preparation/PreparationList.vue'),
        meta: { title: '整备管理', permissions: ['preparation:list'] },
      },
      {
        path: 'inventory',
        name: 'inventory-list',
        component: () => import('@/pc/views/inventory/InventoryList.vue'),
        meta: { title: '库存管理', permissions: ['inventory:list'] },
      },
      {
        path: 'parts',
        name: 'parts-list',
        component: () => import('@/pc/views/inventory/PartsList.vue'),
        meta: { title: '配件管理', permissions: ['inventory:list'] },
      },
      {
        path: 'finance',
        name: 'finance-list',
        component: () => import('@/pc/views/finance/FinanceList.vue'),
        meta: { title: '财务管理', permissions: ['finance:list'] },
      },
      {
        path: 'finance/vehicle-profit',
        name: 'vehicle-profit',
        component: () => import('@/pc/views/finance/VehicleProfit.vue'),
        meta: { title: '单车利润', permissions: ['finance:summary'] },
      },
      {
        path: 'coupons',
        name: 'coupon-list',
        component: () => import('@/pc/views/coupon/CouponList.vue'),
        meta: { title: '优惠券', permissions: ['coupon:list'] },
      },
      {
        path: 'activities',
        name: 'activity-list',
        component: () => import('@/pc/views/activity/ActivityList.vue'),
        meta: { title: '活动管理', permissions: ['activity:list'] },
      },
      {
        path: 'brand-models',
        name: 'brand-model-list',
        component: () => import('@/pc/views/brand-model/BrandModelList.vue'),
        meta: { title: '品牌车型', permissions: ['vehicle:list'] },
      },
      {
        path: 'users',
        name: 'user-list',
        component: () => import('@/pc/views/user/UserList.vue'),
        meta: { title: '用户管理', permissions: ['user:list'] },
      },
      {
        path: 'roles',
        name: 'role-list',
        component: () => import('@/pc/views/role/RoleList.vue'),
        meta: { title: '角色管理', permissions: ['role:list'] },
      },
      {
        path: 'logs',
        name: 'log-list',
        component: () => import('@/pc/views/log/LogList.vue'),
        meta: { title: '操作日志', permissions: ['log:list'] },
      },
      {
        path: 'org-settings',
        name: 'org-settings',
        component: () => import('@/pc/views/org/OrgSettings.vue'),
        meta: { title: '机构设置', permissions: ['org:update'] },
      },
      {
        path: 'profile',
        name: 'pc-profile',
        component: () => import('@/pc/views/profile/Profile.vue'),
        meta: { title: '个人中心' },
      },
      {
        path: 'data-dicts',
        name: 'data-dict-list',
        component: () => import('@/pc/views/dict/DataDictList.vue'),
        meta: { title: '数据字典', permissions: ['data_dict:list'] },
      },
      {
        path: 'todos',
        name: 'todo-list',
        component: () => import('@/pc/views/todo/TodoList.vue'),
        meta: { title: '代办事宜', permissions: ['todo:list'] },
      },
      {
        path: 'leads',
        name: 'lead-list',
        component: () => import('@/pc/views/lead/LeadList.vue'),
        meta: { title: '线索管理', permissions: ['lead:list'] },
      },
      {
        path: 'contracts',
        name: 'contract-list',
        component: () => import('@/pc/views/contract/ContractList.vue'),
        meta: { title: '合同管理', permissions: ['contract:list'] },
      },
      {
        path: 'transfers',
        name: 'transfer-list',
        component: () => import('@/pc/views/transfer/TransferList.vue'),
        meta: { title: '过户管理', permissions: ['transfer:list'] },
      },
      {
        path: 'wechat-bind',
        name: 'pc-wechat-bind',
        component: () => import('@/pc/views/wechat/WechatBind.vue'),
        meta: { public: true, title: '微信绑定' },
      },
      {
        path: 'select-org',
        name: 'pc-select-org',
        component: () => import('@/pc/views/org/SelectOrg.vue'),
        meta: { public: true, title: '选择机构' },
      },
    ],
  },
];
